import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type BreadcrumbItem = {
  title: string;
  link?: string;
};

export type BreadcrumbState = {
  items: BreadcrumbItem[];
};

export const breadcrumbInitialState: BreadcrumbState = {
  items: [],
};

const slice = createSlice({
  name: 'breadcrumb',
  initialState: breadcrumbInitialState,
  reducers: {
    setBreadcrumbItemsAction(state, { payload }: PayloadAction<BreadcrumbItem[]>) {
      state.items = payload;
    },
    clearBreadcrumbAction(state) {
      state.items = [];
    },
  },
});

export const { setBreadcrumbItemsAction, clearBreadcrumbAction } = slice.actions;
export default slice.reducer;
